import { useGraphQLQuery } from '@betterment/js-runtime';

import { ProductCategoryOptionsOrder } from '../../graphql/schema';
import {
  HomeProductOnboardingOptionsDocument,
  HomeProductOnboardingOptionsQuery,
} from '../graphql/homeProductOnboardingOptions.generated';

export type CheckingOptionInManualReview = HomeProductOnboardingOptionsQuery['productOnboardingOptions'][number] & {
  __typename: 'CheckingAccountCreationOption';
};

export const useProductOnboardingOptions = (order?: ProductCategoryOptionsOrder) => {
  const { data } = useGraphQLQuery(HomeProductOnboardingOptionsDocument, {
    throwOnError: true,
    variables: { ...(order ? { orderingOption: order } : {}) },
  });

  if (!data) return { data };

  const { productOnboardingOptions: options, envelopes } = data;

  const hasEnvelopes = !!envelopes.length;
  const crossSellOptions = hasEnvelopes ? options : [];
  const initialOptions = !hasEnvelopes
    ? options.filter(o => !('hasScheduledMeeting' in o && o.hasScheduledMeeting))
    : [];
  const goalCreationIntents = data.goalCreationIntents.filter(i => i.isUserSelected);
  const checkingReceivedInvitations = data.checkingReceivedInvitations.filter(i =>
    ['INVITE_SENT', 'ACCOUNT_CREATED'].includes(i.status)
  );
  const checkingOptionInManualReview = options
    .filter(o => o.__typename === 'CheckingAccountCreationOption')
    .find(o => 'isInManualReview' in o && o.isInManualReview);
  const inProgressOptions = goalCreationIntents.length > 0 ? [] : initialOptions.filter(o => o.isInProgress);
  const notInProgressOptions = initialOptions.filter(o => !o.isInProgress);

  return {
    data: {
      crossSellOptions,
      inProgressOptions,
      notInProgressOptions,
      intents: {
        goalCreationIntents,
        checkingReceivedInvitations,
        checkingOptionInManualReview,
      },
    },
  };
};
